import { ProcessorSwitch } from '../../atoms/processor-switch';
import { RegisterTerminalJustifi } from './register-terminal-justifi';
import { RegisterTerminalStripe } from './register-terminal-stripe';

export const RegisterTerminalSwitch = () => {
  return <ProcessorSwitch stripeContent={RegisterTerminalStripe} justifiContent={RegisterTerminalJustifi} />;
};
